import styled from 'styled-components';
import { Col } from 'antd';
import Color from 'constants/color';

interface StyledProps {
  $isMobileView: boolean;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: block;
`;

export const LayoutsButtonCenter = styled.div`
  align-items: center;
  text-align: center;
  padding: 5px;
`;

export const ContainerWhiteGray = styled.div`
  width: 100%;
  height: 100%;
  display: block;

  .group-header {
    display: flex;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    .name {
      font-size: 24px;
      font-weight: 700;
    }
    .btn-group {
      display: flex;
      column-gap: 8px;
    }
  }
  /* background: ${Color.whteGray2}; */
`;

export const FilterBackground = styled.div<StyledProps>`
  /* display: ${(props) => props.$isMobileView && 'flex'}; */
  justify-content: ${(props) => props.$isMobileView && 'flex-end'};
  align-items: flex-end;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  z-index: 0;
`;


export const ColLeft = styled(Col)`
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-content: center !important;
  justify-content: flex-start !important;
  align-items: center;
`;

export const ColFlexEnd = styled(Col)`
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-content: center !important;
  justify-content: flex-end !important;
  align-items: center;
`;